import React from "react";
import PropTypes from "prop-types";
import { TextField } from "../../TextField/TextField";
import "./DropdownMenu.scss";

const ENTER_KEY = "Enter";

export class DropdownMenu extends React.Component {
  static defaultProps = {
    showSearch: false,
    isOpen: false,
  };

  static propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onSearchChange: PropTypes.func,
    showSearch: PropTypes.bool,
    setIsOpen: PropTypes.func,
  };

  onSearchClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  onClick = () => {
    const { setIsOpen } = this.props;

    setIsOpen(false);
  };

  onKeyDown = (event) => {
    if (event.key === ENTER_KEY) {
      this.onClick(event);
    }
  };

  render() {
    const { children, isOpen, onSearchChange, showSearch } = this.props;

    return (
      isOpen && (
        <div
          className="dropdownMenu__container"
          onClick={this.onClick}
          onKeyDown={this.onKeyDown}
          role="button"
          tabIndex={0}
        >
          {showSearch && onSearchChange && (
            <TextField
              id="dropdownSearch"
              className="search-component"
              onClick={this.onSearchClick}
              onChange={onSearchChange}
              placeholder="Search..."
              autoFocus
            />
          )}
          {children}
        </div>
      )
    );
  }
}

export default DropdownMenu;
